import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  FormFeedBack,
  ModalBase,
  Select,
} from '@repo/ui';
import { CourseListUseCaseInterface } from 'domain/usecases';
import { FormikValues } from 'formik';
import { Row, Col, Form, Label, Input } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  toggleModal: () => void;
  formik: FormikValues;
  resetForm: () => void;
  isLoadingGetById: boolean;
  isLoadingSubmit: boolean;
  isEdit: boolean;
  courses: {
    options: CourseListUseCaseInterface.Result[];
    loading: boolean;
  };
}

export const ModalSectorsForm = ({
  isOpen,
  formik,
  resetForm,
  toggleModal,
  isEdit,
  courses,
  isLoadingGetById,
  isLoadingSubmit,
}: IProps) => {
  return (
    <ModalBase.Wrapper
      size="lg"
      isOpen={isOpen}
      loading={isLoadingGetById}
      toggle={toggleModal}
      onClosed={resetForm}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        {isEdit ? 'Editar Setor' : 'Novo Setor'}
      </ModalBase.Header>

      <Form autoComplete="off" onSubmit={formik.handleSubmit}>
        <ModalBase.Body>
          <Row className="g-3">
            <Col md={12}>
              <Label htmlFor="sectorName" className="form-label">
                Nome
              </Label>
              <Input
                id="sectorName"
                type="text"
                name="sectorName"
                className="form-control"
                placeholder="Digite o nome do setor"
                value={formik.values.sectorName}
                onChange={formik.handleChange}
                invalid={
                  formik.touched.sectorName && !!formik.errors.sectorName
                }
                autoFocus={true}
              />
              <FormFeedBack
                error={formik.errors.sectorName}
                isInvalid={
                  formik.touched.sectorName && !!formik.errors.sectorName
                }
              />
            </Col>

            <Col md={12}>
              <Label className="form-label">Curso</Label>
              <Select
                isMulti
                isClearable
                closeMenuOnSelect={false}
                placeholder="Selecione o(s) curso(s)"
                options={formatDataToLabelValue(
                  courses.options as never,
                  'id',
                  'nome',
                )}
                value={formik.values.courses}
                onChange={(e) => {
                  formik.handleChange(convertEventSelectToTarget('courses', e));
                }}
                isDisabled={courses.loading}
                isLoading={courses.loading}
                invalid={!!(formik?.touched?.course && formik?.errors?.course)}
              />
              <FormFeedBack
                error={formik.errors.courses as string}
                isInvalid={formik.touched.courses && !!formik.errors.courses}
              />
            </Col>

            <Col md={12}>
              <Label htmlFor="description" className="form-label">
                Descrição
              </Label>
              <Input
                id="description"
                type="text"
                name="description"
                placeholder="Adicione uma descrição (opcional)"
                className="form-control"
                value={formik.values.description}
                onChange={formik.handleChange}
              />
            </Col>

            {isEdit && (
              <Col md={12}>
                <div className="form-check form-switch">
                  <Input
                    id="isActive"
                    name="isActive"
                    type="checkbox"
                    role="switch"
                    className="form-check-input"
                    checked={formik.values.isActive}
                    onChange={formik.handleChange}
                  />
                  <Label
                    className="form-check-label user-select-none"
                    htmlFor="isActive"
                  >
                    {formik.values.isActive ? 'Ativo' : 'Inativo'}
                  </Label>
                </div>
              </Col>
            )}
          </Row>
        </ModalBase.Body>
        <ModalBase.Footer>
          <ModalBase.Actions
            loading={isLoadingSubmit}
            goBack={toggleModal}
            actionBtnType="submit"
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
